import * as React from 'react';
import { Product } from '@grandvisionhq/analytics';
import '../../../context/actions.js';
import '../../../context/reducer.js';
import { useProductData } from '../../../context/product-context-hooks.js';
import '../../../context/ProductContext.js';
import '../../../context/CmsContext.js';
import { getPriceSpecificationConfig } from '../utils/get-price-specification-config.js';
import '@swc/helpers';

const ProductStructuredData = ()=>{
    const { activeVariant , displayPrice , product , productUrl  } = useProductData();
    const { analyticsData , brandName , name  } = product;
    const { category , ratingsSummary , vatRate  } = analyticsData;
    const { description , seoConfig , sku , media: { images  } ,  } = activeVariant;
    const priceSpecification = getPriceSpecificationConfig({
        displayPrice,
        vat: vatRate
    });
    const img = images[0] ? images[0].url : seoConfig.ogImageUrl;
    return /*#__PURE__*/ React.createElement(Product, {
        name: name || seoConfig.metaTitle,
        image: img,
        description: description,
        brand: brandName,
        category: category,
        sku: sku,
        url: productUrl,
        ratingsSummary: ratingsSummary,
        priceSpecificationConfig: priceSpecification,
        isCentAmount: false
    });
};

export { ProductStructuredData };
//# sourceMappingURL=ProductStructuredData.js.map
